
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.91 40.136c-.255-.352-6.686-8.32-14.912-8.32-8.223 0-14.623 8-14.912 8.32a1.351 1.351 0 000 1.728c.256.352 6.687 8.32 14.912 8.32 8.224 0 14.624-8 14.913-8.32a1.44 1.44 0 000-1.728zM39.999 47.4c-5.407 0-10.143-4.48-11.936-6.4 1.793-1.92 6.56-6.4 11.936-6.4 5.377 0 10.144 4.48 11.937 6.4-1.793 1.92-6.53 6.4-11.937 6.4z","fill":"#231F20"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43 41a3 3 0 11-6 0 3 3 0 016 0z","fill":"#C1AB8E"}})])
          )
        }
      }
    